enum IndicativoPresencialConsumidor {
  NaoSeAplica = 0,
  OperacaoPresencial = 1,
  OperacaoNaoPresencial = 2,
  OperacaoNaoPresencialTeleatendimento = 3,
  NFC = 4
}

export default IndicativoPresencialConsumidor;